import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css';
import App from './App';
import { isNative, hideSplash } from './native';

// iPhone app: native-only styles (html.native in App.css), and no ˄ ˅ Done bar above
// the keyboard (the chat has its own Send button). Destructure the plugin: awaiting a
// Capacitor plugin object itself hangs.
if (isNative) {
  document.documentElement.classList.add('native');
  import('@capacitor/keyboard')
    .then(({ Keyboard }) => Keyboard.setAccessoryBarVisible({ isVisible: false }))
    .catch(() => {});
  // Never leave the splash up for good if something fails before the first screen.
  setTimeout(hideSplash, 10000);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

